"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useEffect, useState } from "react";
export default function AboutOmniWealth() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const [isPaused, setIsPaused] = useState(false);
  const images = [{
    id: 1,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1518904/img/luxury_estate_exterior_twilight.png",
    alt: "Luxury estate exterior at twilight"
  }, {
    id: 2,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1518904/img/modern_estate_pool_garden.png",
    alt: "Modern estate with pool and garden"
  }, {
    id: 3,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1518904/img/elegant_estate_entrance_driveway.png",
    alt: "Elegant estate entrance and driveway"
  }];
  return <section id="about-omni-wealth" ref={ref} className="relative py-16 md:py-24 lg:py-32 bg-background">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display text-foreground leading-tight">
              About Omni Wealth
            </h2>
            <div className="space-y-4 text-lg md:text-xl text-foreground/80">
              <p>
                Omni Wealth Management is a premier private property management firm based in Los Angeles, specializing in the exclusive oversight of residential estates for discerning high-net-worth individuals.
              </p>
              <p>
                We deliver discreet, full-service property management, concierge coordination, and comprehensive estate operations, ensuring each property runs seamlessly and securely.
              </p>
              <p>
                Our commitment to personalized attention, confidentiality, and meticulous stewardship reflects our dedication to maintaining the highest standards of luxury property care.
              </p>
            </div>
          </div>

          {}
          <div className="relative">
            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full">
              <CarouselContent>
                {images.map((image, i) => <CarouselItem key={image.id} data-index={i}>
                    <div className="relative aspect-[4/3] rounded-lg overflow-hidden shadow-medium group" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
                      <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] group-hover:scale-105" />
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="left-4" />
              <CarouselNext className="right-4" />
            </Carousel>
          </div>
        </div>
      </div>
    </section>;
}